import { useNavigate } from "react-router-dom";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import Modal from "../../../components/portal/Modal";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import successIcon from "../../../assets/icons/successIcon.svg";

export default function OfficerViewDetailsDialog({ viewDetails }) {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="officer-dialog-content">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">Officer Successfully Created!</p>
      <div className="view-dialog-content-wrap">
        <DetailRow title="Officer ID" value={viewDetails.id} />
        <DetailRow title="Officer Name" value={viewDetails.fullName} />
      </div>
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/officer/all")}
        />
      </div>
    </Modal>
  );
}
